document.addEventListener('DOMContentLoaded', function () {
  const headings = document.querySelectorAll('.mobile-acc-heading');

  function toggleAccordion(event) {
    const heading = event.currentTarget;
    const details = heading.closest('.footer-block').querySelector('.footer-block__details');

    // Close all other open accordions
    document.querySelectorAll('.footer-block__details').forEach((otherDetails) => {
      if (otherDetails !== details) {
        otherDetails.classList.remove('open');
        otherDetails.previousElementSibling.classList.remove('open'); // Remove 'open' from heading
      }
    });

    // Toggle the current accordion
    heading.classList.toggle('open');
    details.classList.toggle('open');
  }

  function enableAccordion() {
    if (window.innerWidth <= 768) {
      headings.forEach((heading) => {
        heading.addEventListener('click', toggleAccordion);
      });
    } else {
      headings.forEach((heading) => {
        heading.removeEventListener('click', toggleAccordion);
        heading.classList.remove('open');
        heading.closest('.footer-block').querySelector('.footer-block__details').classList.remove('open');
      });
    }
  }
  enableAccordion();
  window.addEventListener('resize', enableAccordion);

  
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".facets__disclosure").forEach((details) => {
        details.addEventListener("toggle", function () {
            if (this.open) {
                // Close other details elements
                document.querySelectorAll(".facets__disclosure").forEach((el) => {
                    if (el !== this) {
                        el.classList.remove("opening");
                        el.classList.add("closing");
                        el.removeAttribute("open"); // Ensure only one stays open
                    }
                });

                // Mark this one as opening
                this.classList.remove("closing");
                this.classList.add("opening");
            } else {
                // Check if at least one <details> is still open
                const anyOpen = document.querySelector(".facets__disclosure[open]");

                if (!anyOpen) {
                    // If none are open, remove "closing" from all
                    document.querySelectorAll(".facets__disclosure").forEach((el) => {
                        el.classList.remove("closing");
                    });
                }

                this.classList.remove("opening");
            }
        });
    });

    // Remove "closing" from all when clicking outside
    document.addEventListener("click", function (event) {
        if (!event.target.closest(".facets__disclosure")) {
            document.querySelectorAll(".facets__disclosure").forEach((el) => {
                el.classList.remove("closing", "opening");
                el.removeAttribute("open"); // Ensures all close when clicking outside
            });
        }
    });
});




